import { useSelector } from 'react-redux'
import type { State } from '../../Slice/index.js'
import { applicationSlice } from '../../Slice/Application/ApplicationSlice.js'

export const useGetConnectivity = () => {
  return useSelector(selectConnectivity)
}

const selectConnectivity = (state: typeof State) => state[applicationSlice.name].connectivity
